var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{staticStyle:{"display":"inline-flex","position":"relative"}},[_vm._t("activator"),_c('v-fade-transition',[(hover)?_c('v-card',{class:_vm.$root.br.smAndDown
                        ? 'cell-tooltip-hover full-width'
                        : _vm.classList,style:(_vm.cardStyle)},[(_vm.text)?_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}):_vm._t("default")],2):_vm._e()],1)],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }